import(/* webpackMode: "eager" */ "/vercel/path0/src/app/battles/page.tsx");
